import {AfterViewInit, ChangeDetectionStrategy, Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR} from "@angular/forms";

declare let $: any;

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ]
})

export class SelectComponent implements ControlValueAccessor, AfterViewInit {
  @Input() inputStyle: string; // 'default' or 'rounded'
  @Input() inputSize: string; // 'form-control-lg', 'form-control-sm', or empty for default size
  @Input() options: any[]; // options array containing objects with 'value' and 'label' properties
  @Input() placeholder: string; // placeholder text for the input field
  @Input() liveSearchId: string; // Select2 relation Element Id
  @Input() customClass: string; // custom class
  @Input() multiple: string; // multiple
  @Input() searchable: string; // -1 : close, 1:open

  @Input() formGroupParent: FormGroup;
  @Input() formGroupControlName: string;
  @Input() selectedValue: any;

  private propagateOnChange = (value: { label: string, value: any }[]) => {
  };
  private propagateTouched = (value: { label: string, value: any }[]) => {
  };

  writeValue(items: { label: string, value: any }[]) {
    this.options = items;
  }

  registerOnChange(fn: any) {
    this.propagateOnChange = fn;
  }

  registerOnTouched(fn: any) {
    this.propagateTouched = fn;
  }

  change(e: any) {
    this.selectedValue = e.target.options[e.target.options.selectedIndex].value;
    console.log("selected Item = " + this.selectedValue)
  }

  ngAfterViewInit() {
    if (this.liveSearchId) {
      $('#' + this.liveSearchId).select2({
        minimumResultsForSearch: this.searchable,
        /*placeholder: this.placeholder,*/
        allowClear: true,
      }).on('select2:select', (event: any) => {
        this.formGroupParent.patchValue({[this.formGroupControlName]: event.params.data.id == "" ? null : event.params.data.id })
      });


      this.formGroupParent.controls[this.formGroupControlName].valueChanges
        .subscribe(selectedItem => {
          this.selectedValue = selectedItem;
          $('#' + this.liveSearchId).val(this.selectedValue).trigger('change');
        });
    }
  }
}
